module.exports = __webpack_public_path__ + "static/chirurgia-56b2c047e90f290d11ba48da8053a550.svg";